import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createUOM,
  fetchAllUOMs,
  updateUOM,
  fetchOneUOM,
  deleteUOM,
} from "services/uom";

// Fetch all UOMs with optional filtering
export const useAllUOMs = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["uoms", filters],
    queryFn: () => fetchAllUOMs(filters),
    enabled,
  });
};

// Fetch single UOM by ID
export const useOneUOM = (id, enabled = true) => {
  return useQuery({
    queryKey: ["uom", id],
    queryFn: () => fetchOneUOM(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new UOM
export const useCreateUOM = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createUOM(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["uoms"] });
    },
  });
};

// Update existing UOM
export const useUpdateUOM = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateUOM({ id, data }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["uoms"] });
      queryClient.invalidateQueries({ queryKey: ["uom", variables.id] });
    },
  });
};

// Delete UOM
export const useDeleteUOM = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteUOM(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["uoms"] });
      queryClient.invalidateQueries({ queryKey: ["uom", id] });
    },
  });
};
